import { IACDLEvent } from '../../../../../services/eventBus.service';

export const SegmentationDeletedEventType = Symbol('SEGMENTATION_DELETED_EVENT');

export class SegmentationDeletedEvent implements IACDLEvent {
  constructor(public readonly segmentationId: string) {}

  get type(): symbol {
    return SegmentationDeletedEventType;
  }
}
